export const apiPath = '/v2/tag_names';
const actionType = 'TAG_NAME';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
